import { DEFAULT_SENTRY_OPTIONS, JSON_PARSING_ERROR, stringifyError } from 'actions/ApiCaller';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
const isParsedResponse = (response) => {
    return !(response instanceof Response);
};
export const sendToSentry = (error, config) => {
    if (ExecutionEnvironment.canUseDOM && config.sendToSentry) {
        const Raven = window.Raven;
        if (!Raven || !Raven.isSetup())
            return;
        if (error instanceof Error) {
            Raven.captureException(error);
        }
        else {
            const errMsg = stringifyError(error, config);
            let options = Object.assign({}, DEFAULT_SENTRY_OPTIONS, { extra: { config, error } });
            // The "fingerprint" option allows grouping of the issues based on
            // that criteria. This helps in NOT listing the json parse failures
            // in the mainline sentry listing
            options =
                isParsedResponse(error) && error.statuscode === JSON_PARSING_ERROR
                    ? Object.assign({}, options, { fingerprint: [JSON_PARSING_ERROR] })
                    : options;
            Raven.captureMessage(errMsg, options);
        }
    }
};
export const logError = (config) => (error) => {
    if (__DEBUG_ENV__) {
        // tslint:disable:no-console
        console.error('ApiCaller Error: ', error);
    }
    // this function returns the promise-wrapped error, or throws an error
    // which returns a promise of some object which is equivalent to rejecting
    // with that object.
    if (config.acceptErrors) {
        sendToSentry(error, config);
        return Promise.reject(error);
    }
    else {
        throw stringifyError(error, config);
    }
};
